/* ============
 * Bill Status Transformer
 * ============
 *
 * The transformer for the billStatuses.
 */

import Transformer from './transformer';

export default class billStatusesTransformer extends Transformer {

  static fetch(billStatuses) {
    return {
      id: billStatuses.id,
      status: billStatuses.status,
    };
  }

  static send(billStatuses) {
    return {
      id: billStatuses.id,
      status: billStatuses.status,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/billStatus.js